var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningInformationCriticalIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51333 2H10.4867L14 5.51333V10.4867L10.4867 14H5.51333L2 10.4867V5.51333L5.51333 2ZM10.0733 13L13 10.0733V5.93333L10.0733 3.00667H5.93333L3.00667 5.93333V10.0733L5.93333 13H10.0733ZM7.99994 7.29335L9.69327 5.60002L10.3999 6.30668L8.7066 8.00002L10.3999 9.69335L9.69327 10.4L7.99994 8.70668L6.3066 10.4L5.59994 9.69335L7.29327 8.00002L5.59994 6.30668L6.3066 5.60002L7.99994 7.29335Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningInformationCriticalIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning_Information_Critical_icon.bd68e2bc0a9c94b97d0e551c9f7fe919.svg";